import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      // @ts-ignore
      return window.scrollTo({ top: document.querySelector(to.hash).offsetTop - 100, behavior: 'smooth' });
    }
    return window.scrollTo({ top: 0, behavior: 'smooth' });
    // if (to.hash) {
    //   console.log('to hash');
    //   return { selector: to.hash, offset: { x: 0, y: 100 } };
    // } if (savedPosition) {
    //   console.log('to location');
    //   return savedPosition;
    // }
    // return { x: 0, y: 0 };
  },
});

export default router;
